<script setup lang="ts">
import { useModalStore } from "~/components/Base/Dialog/modals.store";
const { modals } = useModalStore();
</script>

<template>
  <div>
    <div
      id="modal-container"
      class="fixed inset-0 pointer-events-none top-0 left-0 w-full h-full"
    />
    <div
      id="screenshot-capture"
      class="pointer-events-none fixed z-[999999] top-0 left-0 w-full h-full"
    />
    <Teleport to="#modal-container">
      <BaseDialogComponent
        v-for="modal in modals"
        :key="modal.id"
        :controller="modal.controller"
        :showHeader="modal.showHeader"
        :allowClose="modal.allowClose"
        @close="modal.close()"
      >
        <template #title v-if="modal.title">
          {{ modal.title }}
        </template>
        <template #content>
          <component
            :is="modal.component"
            v-bind="modal.props"
            v-on="modal.listeners"
          />
        </template>
      </BaseDialogComponent>
    </Teleport>
  </div>
</template>
<style scoped></style>
